import store from '@store'

// CurData 显示数据
export const setCurData = data => {
  store.commit('therapy/setCurData', data)
}

// CurData 显示数据
export function commitCurData(data) {
  store.commit('therapy/setCurData', data)
}

// RemainTime 剩余时间
export function commitRemainTime(data) {
  store.commit('therapy/setRemainTime', data)
}

// curdata 清除数据
export function commitClearCurData() {
  store.commit('therapy/clearCurData')
}
// CurData 正确/错误次数
export function commitTank(data) {
  store.commit('therapy/setCurData', {
    关卡: data.level,
    英雄生命: data.heroLife,
    敌人生命: data.enemyLife,
  })
}

// 单位像素 转化 棱镜
export function getStorePxToPrism() {
  return store.getters.singlePixel_prism
}

// update_VD_H 更改 VD
// vdSpeed ==>step
export function commitStoreVD(vdSpeed) {
  store.commit('therapy/vergence/update_VD_H', vdSpeed)
}
// setVergenceMode: 更改 mode
export function commitStoreMode(value) {
  store.commit('therapy/vergence/setVergenceMode', value)
}

// updateRangeMax: 更改 RangeMax
export function commitStoreRangeMax(step) {
  store.commit('therapy/vergence/updateRangeMax', step)
}

// updateRangeMin: 更改 RangeMin
export function commitStoreRangeMin(step) {
  store.commit('therapy/vergence/updateRangeMin', step)
}

// setOSFrequence: 更改 OS Frequence
export function setOSFrequence(step) {
  store.commit('therapy/sight/setOSFrequence', step)
}

// setODFrequence: 更改 OD Frequence
export function setODFrequence(step) {
  store.commit('therapy/sight/setODFrequence', step)
}


